import { Col, Row } from '@rematter/ui-web';

import { InventoryTagData } from './_InventoryItemsModal';
import {
  InventoryItemsModalTagsGrid,
  InventoryTagOption,
} from './InventoryItemsModalTagsGrid';

import { useInventoryGroupStyle } from '~/modules/trade/hooks/useInventoryGroupStyle';
import { useTranslations } from '~/modules/trade/i18n/useTranslations';
import { InventoryItemRecord } from '~/modules/trade/types/load';

export type InventoryItemsModalItemViewProps = {
  selectedItem: InventoryItemRecord;
  tagsForItem: InventoryTagOption[];
  selectedId?: string | null;
  onSelectTag: (tagId: string, tagData: InventoryTagData) => void;
};

//
// ⚛️ ⚛️ ⚛️ INVENTORY ITEMS MODAL ITEM VIEW ⚛️ ⚛️ ⚛️
//
export const InventoryItemsModalItemView = ({
  selectedItem,
  tagsForItem,
  selectedId,
  onSelectTag,
}: InventoryItemsModalItemViewProps) => {
  // Translations
  const t = useTranslations();

  // Other data hooks
  const groupStyle = useInventoryGroupStyle({
    colorHue: selectedItem.itemGroup?.colorHue ?? undefined,
  });

  return (
    <Col className="@InventoryItemsModalItemView" gap6>
      <Row yCenter gap3>
        <div
          style={groupStyle}
          className="@SelectedItemIcon h-[44px] w-[35px] max-w-[35px] rounded-md border-2 border-neutral/20"
        />
        <Col gap1>
          <div className="text-sm text-neutral/60">
            {selectedItem.itemGroup?.name}
          </div>
          <div className="text-xl font-medium">{selectedItem.name}</div>
        </Col>
      </Row>

      <InventoryItemsModalTagsGrid
        tags={tagsForItem}
        selectedId={selectedId}
        onSelectTag={onSelectTag}
        emptyMessage={t.inventoryItemsModal.noTagsInGroup}
      />
    </Col>
  );
};
